import { makeAutoObservable } from 'mobx';
import fetchService from '../servises/fetch.service';
import { registerAccountStateReset } from '../servises/account-state.service';

class UptimeChecksStore {
    constructor() {
        makeAutoObservable(this);
    }

    uptimeChecksList = [];
    requestSequence = 0;

    async getUptimeChecks(uptimeId) {
        const requestSequence = ++this.requestSequence;
        const response = await fetchService.authenticatedGet(
            `/uptimeChecks/${ uptimeId }`);
        const responseData = response.data.data_o;
        const data = responseData === null ? [] : responseData;
        if (requestSequence === this.requestSequence && Array.isArray(data)) {
            this.uptimeChecksList = [...data].reverse();
        }
    }

    clear() {
        this.requestSequence += 1;
        this.uptimeChecksList = [];
    }
}

const uptimeCheckStore = new UptimeChecksStore();
registerAccountStateReset(() => uptimeCheckStore.clear());

export default uptimeCheckStore;
